import $ from 'jquery';
import hljs from 'highlight.js';

$(document).ready(() => {
  $('pre code').each((i, block) => {
    hljs.highlightBlock(block);
  });
});



// WEBPACK FOOTER //
// ./_components/code-snippet-block/index.js